import { faSkullCrossbones } from "@fortawesome/free-solid-svg-icons";
export const Logo = faSkullCrossbones;
